import React from "react";
import { Route } from "react-router-dom";

import "./App.scss";

import * as menuActions from './actions/menuActions';
import * as loginActions from "./actions/loginActions";
import withMeta from './coraWebComponents/utils/withMeta';
import MetaRoute, { AuthLayout } from './coraWebComponents/meta/MetaRoute';
import Routes from "./constants/Routes";

import { connect } from 'react-redux';

import akcFactory from './meta/akcFactory';
import componentFactory from './meta/componentFactory';
import reducer from './meta/reducer';

import LocalizationProviderWrapper from "./coraWebComponents/localization/withLocalization";

// COMMON Components
import Brand from "./components/brand/Brand";
import Home from "./components/home/Home";
import Faq from "./components/faq/Faq";
import Login from "./components/login/Login";
import OAuthHandler from "./components/oauth/OAuthHandler";
import Registracia from "./components/registracia/Registracia";
import User from "./components/User/User";
import InfoUser from "./components/User/InfoUser";

// Components
import AppHeader from "./zisComponents/appHeader/AppHeader";
import ForgotPassword from "./components/forgotPassword/ForgotPassword";
import Spravy from "./components/spravy/Spravy";
import PodatZiadost from "./components/podatZiadost/PodatZiadost";
import MojeZiadosti from "./components/ziadosti/MojeZiadosti";
import VsetkyZiadosti from "./components/ziadosti/VsetkyZiadosti";
import MojeUlohy from "./components/ulohy/MojeUlohy";
import VytvoritVyjadrenie from "./components/vyjadrenie/VytvoritVyjadrenie";

let _init;
class App extends React.Component {
  initMenu = () => {
    this.props.meta.initMenu();
    this.forceUpdate();
  };

  handleOnClickBody = (e) => {
    // classes exist only on mobile screen
    const htmlCollection =
      document.getElementsByClassName("w-sidebar overBody");

    // if exist, sideBar expanded -> fire click event to collpase sidebar
    if (htmlCollection.length > 0) document.querySelector(".hamburger").click();
  };

  render() {
    const { isAuth, meta, msg, hideMsg } = this.props;

    if (isAuth) {
      if (!_init) {
        _init = true;
        meta.init();
      }
    } else {
      _init = false;
    }

    const header = <AppHeader />;

    const navUser = (props) => (
      <User
        uzivatel={props.uzivatel}
        onSignOut={props.onSignOut}
        userInfo={props.userInfo}
        handleOpenSettings={props.handleOpenSettings}
      />
    );

    return (
      <LocalizationProviderWrapper locale={"sk-SK"} >
          <MetaRoute
            user={this.props.user}
            menu={this.props.meta.menuTree}
            menuList={this.props.meta.menu}
            isSetHomePage={true}
            initMenu={this.initMenu}
            onMenuFilter={this.props.getMenu}
            msg={'test'}
            brand={<Brand />}
            onHideMsg={() => { }}
            onSignOut={this.props.signOut}
            handleConfirmChangePassword={this.props.handleConfirmChangePassword}
            navUser={navUser}
            header={header}
            theme="default"
            themes={[{ name: "default", title: "Svetlá"}, { name: "dark", title: "Tmavá"}]}
            updateMenu={this.initMenu}
            isNavBarNotScrollable={this.props.isAuth}
            isPath={true}
            akcFactory={akcFactory}
            componentFactory={componentFactory}
            reducer={reducer}
            loginPage={Login}
            isAuth={this.props.isAuth}
            useOverlaySidebarTypeOnExpand={true}
            onClickBody={this.handleOnClickBody}
            sideBarToggleIcons={{
              compactIcon: "k-i-reorder",
              normalIcon: "k-i-reorder",
              fullscreen: "k-i-reorder",
              hamburgerIcon: "k-i-reorder",
            }}
            customRoutes={<>
              <Route element={<AuthLayout isAuth={this.props.isAuth} key={1} />}>
                <Route element={<Home />} path={Routes.HOME} key={1} />

                <Route element={<Faq />} path={Routes.FAQ} key={6} />
                <Route element={<Spravy />} path={Routes.SPRAVY} key={7} />
                <Route element={<PodatZiadost />} path={Routes.PODAT_ZIADOST} key={8} />
                <Route element={<MojeZiadosti />} path={Routes.MOJE_ZIADOSTI} key={9} />
                <Route element={<VsetkyZiadosti />} path={Routes.VSETKY_ZIADOSTI} key={10} />
                <Route element={<MojeUlohy />} path={Routes.MOJE_ULOHY} key={11} />
                <Route element={<VytvoritVyjadrenie />} path={Routes.VYTVORIT_VYJADRENIE} key={12} />
                <Route element={<InfoUser />} path={Routes.INFO_USER} key={13} />
              </Route>
              <Route element={<Registracia />} path={Routes.REGISTRACIA} key={2} />
              <Route element={<OAuthHandler />} path={Routes.OAUTH_HANDLER} key={3} />
              <Route element={<ForgotPassword />} path={Routes.FORGOT_PASSWORD} key={4} />
            </>}
          />        
      </LocalizationProviderWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
    isAuth: state.user.data !== null,
    menu: window.config.menu,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleConfirmChangePassword: (newPassword) => dispatch(loginActions.changePassword({ newPassword })),
  signOut: () => dispatch(loginActions.signOut()),
  getMenu: (filter) => dispatch(menuActions.getMenu(filter)),
});

export default withMeta(connect(mapStateToProps, mapDispatchToProps)(App));
